import { Button as MuiButton } from '@mui/material';

function Button({ children, onClick, variant = 'primary', type = 'button', disabled = false, ...rest }) {
  const map = {
    primary: { variant: 'contained', color: 'primary' },
    secondary: { variant: 'outlined', color: 'primary' },
    ghost: { variant: 'text', color: 'inherit' },
    muted: { variant: 'contained', color: 'ghost' },
    light: { variant: 'outlined', color: 'inherit' },
    danger: { variant: 'outlined', color: 'error' },
    reverse: { variant: 'contained', color: 'reverse' },
  };
  const mapped = map[variant] || map.primary;
  return (
    <MuiButton variant={mapped.variant} color={mapped.color} type={type} onClick={onClick} disabled={disabled} {...rest}>
      {children}
    </MuiButton>
  );
}

export default Button;
